import { type FC } from 'react';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { NavLink } from 'react-router';
import {
  Calculate,
  ChecklistRtl,
  Construction,
  Light,
  LocationCity,
  Settings,
  Shower,
} from '@mui/icons-material';

type CommonLinks = {
  auditSettings: string;
};

export type EnergyAuditFormsLinks = {
  background: string;
  waterFixture: string;
  lighting: string;
  lightingCount: string;
  mechanical: string;
  checklist: string;
};

export type AuditDetailsPageLinks = CommonLinks & {
  energyAudit: EnergyAuditFormsLinks;
};

export type AuditDetailsPageRendererProps = {
  links: AuditDetailsPageLinks;
};

export const AuditDetailsPageRenderer: FC<AuditDetailsPageRendererProps> = ({
  links,
}) => (
  <List sx={{ flexGrow: 1 }}>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.background}>
        <ListItemIcon>
          <LocationCity />
        </ListItemIcon>
        <ListItemText
          primary="Background"
          secondary="General information about the audit"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton
        component={NavLink}
        to={links.energyAudit.waterFixture}
        disabled>
        <ListItemIcon>
          <Shower />
        </ListItemIcon>
        <ListItemText
          primary="Water"
          secondary="Water fixtures and usage details"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton
        component={NavLink}
        to={links.energyAudit.lighting}
        disabled>
        <ListItemIcon>
          <Light />
        </ListItemIcon>
        <ListItemText
          primary="Lighting Types"
          secondary="Lighting conditions and setup"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton
        component={NavLink}
        to={links.energyAudit.lightingCount}
        disabled>
        <ListItemIcon>
          <Calculate />
        </ListItemIcon>
        <ListItemText
          primary="Lighting Count"
          secondary="Count and types of lighting fixtures"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.mechanical}>
        <ListItemIcon>
          <Construction />
        </ListItemIcon>
        <ListItemText
          primary="Mechanical"
          secondary="Mechanical details and specifications"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.energyAudit.checklist}>
        <ListItemIcon>
          <ChecklistRtl />
        </ListItemIcon>
        <ListItemText
          primary="Checklist"
          secondary="Check if everything is collected"
        />
      </ListItemButton>
    </ListItem>
    <ListItem divider={true}>
      <ListItemButton component={NavLink} to={links.auditSettings}>
        <ListItemIcon>
          <Settings />
        </ListItemIcon>
        <ListItemText
          primary="Settings"
          secondary="Audit configuration and preferences"
        />
      </ListItemButton>
    </ListItem>
  </List>
);
